'use client';

import { getCookie } from 'cookies-next/client';

import { AUTH_COOKIE } from '@/constants/cookies';
import { getDecodedJwt } from '@/utils/getDecodedJwt';

interface DecodedAuthCookie {
  accessToken?: string;
  accountType?: string;
  device?: string;
  deviceId?: string;
  dma?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  profileId?: string;
  refreshToken?: string;
  tokenExpiration?: number;
  userType?: string;
  viewerId?: string;
}

export function getUserInfo(): Foxkit.UserCookie {
  const authCookie = getCookie(AUTH_COOKIE);

  const decodedAuthCookie: DecodedAuthCookie = JSON.parse(decodeURIComponent(authCookie || '{}')) || {};

  // Temporary replacement of accountType with atype; AUTH_COOKIE is current not returning the correct accountType value
  const accountType = getDecodedJwt(decodedAuthCookie.accessToken).atype;

  const user = {
    ...decodedAuthCookie,
    accountType,
  };

  return user;
}
